import React from 'react';
import TableComponent from '../../components/TableComponent';
import Routes from '../../constants/routes';
import { StoreService } from '../../service';
import Utils from '../../Utils';
const tableHead = [
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'categories',
    label: 'Categorias',
  },
  {
    id: 'localization',
    label: 'Endereço',
  },
];
class FoodStoreList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
    };
    this.getPage();
  }

  async getPage() {
    try {
      const res = await StoreService.all('food');
      this.setState({ data: res.data.data, loading: false });
    } catch (e) {
      console.log(e);
    }
  }

  onCreateClick = () => {
    this.props.history.push(Routes.newRestaurant);
  };

  onEditClick = id => {
    this.props.history.push(Routes.editRestaurant.replace(':id', id));
  };

  onDeleteClick = item => {
    Utils.alertRemove(StoreService, this.state.data, item).then(data => {
      this.setState({ data });
    });
  };

  render() {
    return (
      <TableComponent
        loading={this.state.loading}
        tableTitle="Restaurantes"
        tableHead={tableHead}
        addText="Novo"
        data={this.state.data}
        onCreateClick={this.onCreateClick}
        onEditClick={this.onEditClick}
        onDeleteClick={this.onDeleteClick}
      />
    );
  }
}

export { FoodStoreList };
